import { action } from 'mobx';
import { CheckoutPageModel } from './model';
import { RouterState, RedirectFunction } from 'react-router';
import { UIController } from '../../ui/controller';
import { CheckoutController } from '../../checkout/controller';
import { EnvModel } from '../../env/model';
import { CheckoutModel } from '../../checkout/model';
import {CHECKOUT_STEPS} from '../../../constants';
import {stripQueryString} from '../../../lib/string';

export class CheckoutPageController {
  constructor(
    private model: CheckoutPageModel,
    private checkout: CheckoutController,
    private checkoutModel: CheckoutModel,
    private ui: UIController,
    private env: EnvModel
  ) { }

  @action
  init = (step: number) => {
    const promises = [this.env.ready];

    const isDownload = step === 3;

    if (!isDownload && this.checkoutModel.inProgress === false) {
      promises.push(this.checkout.selectStep(0));
    }

    if(isDownload){
      promises.push(this.checkout.selectStep(3));
    }

    this.checkoutModel.step = step;

    return Promise.all(promises);
  };

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    const step = CHECKOUT_STEPS.indexOf(stripQueryString(nextState.params['step']));

    if (step === -1) {
      return replace({
        pathname: '/checkout/review'
      });
    }

    await this.ui.setSEO(nextState.location.pathname);

    this.ui.setBreadcrumbs([{
      path: '/checkout',
      label: 'Checkout'
    }]);

    this.ui.setSolidHeader(true);
    return this.init(step);
  };

  @action
  onLeave = () => {
    this.ui.setSolidHeader(false);
  };
}